<template>
  <section class="van-doc-demo-block">
    <h2 class="van-doc-demo-block__title">{{ title }}</h2>
    <slot />
  </section>
</template>

<script>
export default {
  name: "van-doc-demo-block",
  props: {
    title: String,
  },
};
</script>

<style lang="less">
@import "~@/less/var.less";

.van-doc-demo-block {
  &__title {
    margin: 0;
    font-weight: normal;
    font-size: 14px;
    color: rgba(69, 90, 100, 0.6);
    padding: 35px 15px 15px;
    background-color: @background;
  }
  &:first-of-type {
    .van-doc-demo-block__title {
      padding-top: 20px;
    }
  }
}
</style>
